import React, { useEffect, useState } from 'react';
import axios from 'axios';
import bookmaker from '../../../../assets/icons/bookmaker-svgrepo-com.svg';
import { HiPencil } from 'react-icons/hi';
import { CgClose } from 'react-icons/cg';
import Modal from '../../../../../components/Modal';
import Input from '../../../../../components/Form/Input';
import Select from '../../../../../components/Form/Select';
import { RESUME_API_END_POINT } from '../../../../../utils/constant';
import { FaUser, FaPhone, FaBirthdayCake, FaVenusMars, FaMapMarkerAlt, FaGraduationCap, FaBriefcase, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { useSelector } from 'react-redux';
import { useOutletContext } from 'react-router-dom';
import ButtonBlack from '../../../../../components/Buttons/ButtonBlack';

const PersonnalInfo = ({ data, setData }) => {
  const [showModal, setShowModal] = useState(false)
  const {user} = useSelector(store=>store.user)
  const {showNotif, setShowNotif} = useOutletContext()
  const [isLoading, setIsLoading] = useState(false)

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    date_birth: "",
    gender: "",
    address: "",
    level: "",
    highest_diploma: "",
    current_job: "",
    is_avalaible: false,
  });

  // Mettre à jour le formulaire avec les données existantes
  useEffect(() => {
    if (data) {
      setFormData({
        name: data?.name || "",
        phone: data?.phone || "",
        date_birth: data?.date_birth || "",
        gender: data?.gender || "",
        address: data?.address || "",
        level: data?.level || "",
        highest_diploma: data?.highest_diploma || "",
        current_job: data?.current_job || "",
        is_avalaible: data?.is_avalaible || false,
      });
    }
  }, [data]);

  // Gestion des changements de champs
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Enregistrer les modifications
  const handleSave = async () => {
setIsLoading(true)
      const response = await axios.post(RESUME_API_END_POINT + "/updateDetail/"+user?.id, formData)
      .then((response)=>{
        setShowNotif({ ...showNotif, variant: "success", message: response?.data?.message, show: true });
        console.log("Mise à jour réussie", response.data);
        setIsLoading(false)
        setShowModal(false);
      }).catch( (error) =>{
        setIsLoading(false)
        setShowNotif({ ...showNotif, variant: "danger", message: "Une erreur est survenue", show: true });
        console.error("Erreur lors de la mise à jour", error);
    })
  };

  const personalInfoFields = [
    { label: "Nom", value: formData.name, icon: <FaUser className="w-5 h-5 text-neutral-500" /> },
    { label: "Téléphone", value: formData.phone || "Non renseigné", icon: <FaPhone className="w-5 h-5 text-neutral-500" /> },
    { label: "Date de naissance", value: formData.date_birth, icon: <FaBirthdayCake className="w-5 h-5 text-neutral-500" /> },
    { label: "Sexe", value: formData.gender, icon: <FaVenusMars className="w-5 h-5 text-neutral-500" /> },
    { label: "Adresse", value: formData.address, icon: <FaMapMarkerAlt className="w-5 h-5 text-neutral-500" /> },
    { label: "Niveau", value: formData.level, icon: <FaGraduationCap className="w-5 h-5 text-neutral-500" /> },
    { label: "Diplôme le plus élevé", value: formData.highest_diploma, icon: <FaGraduationCap className="w-5 h-5 text-neutral-500" /> },
    { label: "Poste actuel", value: formData.current_job, icon: <FaBriefcase className="w-5 h-5 text-neutral-500" /> },
    { 
      label: "Disponible", 
      value: formData.is_avalaible ? "Oui" : "Non", 
      icon: formData.is_avalaible ? <FaCheckCircle className="w-5 h-5 text-green-500" /> : <FaTimesCircle className="w-5 h-5 text-red-500" />
    },
  ];

  return (
    <div className="flex-col text-start border p-4 rounded-md">
      <div className="flex justify-between items-center mb-4">
        <div className="font-semibold">Informations personnelles</div>
        <button onClick={() => setShowModal(true)} className="bg-neutral-50 border rounded-sm p-1">
          <HiPencil className="w-5 h-5 text-neutral-500" />
        </button>
      </div>

      {/* Affichage des informations personnelles */}
      <div className="grid grid-cols-2 gap-6">
      {personalInfoFields.map((info, index) => (
    <div key={index} className="py-2 text-primary-text flex gap-4 items-center rounded-sm">
      <div className="w-10 h-10 bg-neutral-50 border flex items-center justify-center rounded-sm">
        {info.icon}
      </div>
      <div className="flex flex-col gap-y-1 text-primary-black">
        <p className="text-start font-semibold">{info.label}</p>
        <p>{info.value}</p>
      </div>
    </div>
  ))}
      </div>

      <hr className="my-4" />

      {/* Modal pour modifier les informations */}
      <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
        <div className="flex items-center justify-between py-2 px-4">
          <p>Modifier les informations personnelles</p>
          <button onClick={() => setShowModal(false)} className="px-2 py-2 rounded-md border text-primary-black">
            <CgClose />
          </button>
        </div>
        <hr className="mb-6" />

        <div className="px-6 space-y-4 mb-4">
          <Input label="Nom" name="name" value={formData.name} onChange={handleChange} />
          <Input label="Téléphone" name="phone" value={formData.phone} onChange={handleChange} />
          <Input label="Date de naissance" type="date" name="date_birth" value={formData.date_birth} onChange={handleChange} />
          <Select
            label="Sexe"
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            options={["Homme", "Femme", "Autre"]}
          />
          <Input label="Adresse" name="address" value={formData.address} onChange={handleChange} />
          <Input label="Niveau" name="level" value={formData.level} onChange={handleChange} />
          <Input label="Diplôme le plus élevé" name="highest_diploma" value={formData.highest_diploma} onChange={handleChange} />
          <Input label="Métier actuel" name="current_job" value={formData.current_job} onChange={handleChange} />
          
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="is_avalaible"
              name="is_avalaible"
              checked={formData.is_avalaible}
              onChange={handleChange}
              className="w-5 h-5"
            />
            <label htmlFor="is_avalaible" className="text-sm">Disponible</label>
          </div>
        </div>

        <div className="flex items-center justify-end p-6">
          <ButtonBlack isLoading={isLoading} onClick={handleSave} className="py-2 px-6 rounded-sm shadow bg-primary-black text-white">
            Enregistrer
          </ButtonBlack>
        </div>
      </Modal>
    </div>
  );
};

export default PersonnalInfo;

// const PersonnalInfo = ({data, setData}) => {
//   const [showModal, setShowModal] = useState(false);
//   const [formData, setFormData] = useState({
//     email: 'johndoe@gmail.com',
//     birthDate: '01 Janvier 2011',
//     gender: 'Féminin',
//     phone: '',
//     currentJob: 'Étudiant',
//   });

//   // Handle input change
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({ ...prevData, [name]: value }));
//   };

//   // Handle form submission
//   const handleSave = async () => {
//     try {
//       const response = await axios.put(USER_API_END_POINT+'/updateDetail', formData); // Update with your endpoint
//       console.log('Update successful', response.data);
//       setShowModal(false);
//     } catch (error) {
//       console.error('Error updating personal information', error);
//     }
//   };

//   useEffect(() => {
//     if (data) {
//       setFormData({
//         email: data?.user?.email,
//         birthDate: data?.date_birth,
//         gender: data?.gender,
//         phone: data?.phone,
//         currentJob: data?.current_job,
//       });
//     }
//   }, [data]);

//   return (
//     <div className="flex-col text-start border p-4 rounded-md">
//       <div className="flex justify-between items-center mb-4">
//         <div className="font-semibold">Information personnel</div>
//         <button onClick={() => setShowModal(true)} className="bg-neutral-50 border rounded-sm p-1">
//           <HiPencil className="w-5 h-5 text-neutral-500" />
//         </button>
//       </div>

//       {/* Display personal information fields */}
//       <div className="grid grid-cols-2 gap-6">
//         {[
//           { label: 'Email', value: formData.email },
//           { label: 'Date de naissance', value: formData.birthDate },
//           { label: 'Sexe', value: formData.gender },
//           { label: 'Téléphone', value: formData.phone || 'Non renseigné' },
//           { label: 'Poste actuel', value: formData.currentJob },
//         ].map((info, index) => (
//           <div key={index} className="py-2 text-primary-text flex gap-4 items-center rounded-sm">
//             <div className="w-10 h-10 bg-neutral-50 border flex items-center justify-center text-white rounded-sm">
//               <img src={bookmaker} alt="icon" className="w-5 h-5" />
//             </div>
//             <div className="flex flex-col gap-y-1 text-primary-black">
//               <p className="text-start font-semibold">{info.label}</p>
//               <p>{info.value}</p>
//             </div>
//           </div>
//         ))}
//       </div>

//       <hr className="my-4"/>

//       {/* Modal for editing personal information */}
//       <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
//         <div className="flex items-center justify-between py-2 px-4">
//           <p>Modifier les informations personnelles</p>
//           <button onClick={() => setShowModal(false)} className="px-2 py-2 rounded-md border text-primary-black">
//             <CgClose />
//           </button>
//         </div>
//         <hr className="mb-6" />
//         <div className="px-6 space-y-4 mb-4">
//           <Input label="Email" name="email" value={formData.email} onChange={handleChange} />
//           <Input label="Date de naissance" name="birthDate" value={formData.birthDate} onChange={handleChange} />
//           <Select
//             label="Sexe"
//             name="gender"
//             value={formData.gender}
//             onChange={(e) => setFormData({ ...formData, gender: e.target.value })}
//             options={["Féminin", "Masculin"]}
//           />
//           <Input label="Téléphone" name="phone" value={formData.phone} onChange={handleChange} />
//           <Input label="Métier actuel" name="currentJob" value={formData.currentJob} onChange={handleChange} />
//         </div>
//         <div className="flex items-center justify-end p-6">
//           <button onClick={handleSave} className="py-2 px-6 rounded-sm shadow bg-primary-black text-white">
//             Enregistrer
//           </button>
//         </div>
//       </Modal>
//     </div>
//   );
// };

// export default PersonnalInfo;
